/** Silent-renew callback iframe target. react-oidc-context handles the
 * actual token refresh in the background; we just return a minimal page
 * so the iframe load resolves. */
export default function AuthSilentRenew() {
  return null;
}
